import React from 'react';
import { Button } from 'primereact/button';
import RecipeCard from './RecipeCard';

import appetizerImg from '../../assets/cooking/appetizer.jpg';
import breakfastImg from '../../assets/cooking/breakfast.jpg';
import dessertImg from '../../assets/cooking/dessert.jpg';
import lunchImg from '../../assets/cooking/lunch.jpg';
import saladImg from '../../assets/cooking/salat.jpg';
import soupImg from '../../assets/cooking/soup.jpg';

// Map category keys to images. Note: categories use 'mainCourse' (camelCase).
const categoryImages = {
    appetizer: appetizerImg,
    breakfast: breakfastImg,
    dessert: dessertImg,
    mainCourse: lunchImg,      // Correct key for Main Course
    salad: saladImg,
    soup: soupImg,
    // Legacy fallback (if any stale data still uses lowercase 'maincourse')
    maincourse: lunchImg
};

const CategoryShowcase = ({
                              selectedCategory,
                              onBackClick,
                              categoryRecipes,
                              loadingCategories,
                              onRecipeClick,
                              categories,
                              lastUpdated,
                              onCategoryClick
                          }) => {
    if (selectedCategory) {
        return (
            <div className="category-showcase">
                <div className="category-banner" style={{
                    backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.7), rgba(0,0,0,0.3)), url(${categoryImages[selectedCategory.key]})`,
                    backgroundColor: selectedCategory.color,
                    backgroundPosition: 'center'
                }}>
                    <Button
                        icon="pi pi-arrow-left"
                        className="back-button"
                        onClick={onBackClick}
                        text
                    />
                    <h2>{selectedCategory.name} Recipes</h2>
                    <p>{categoryRecipes[selectedCategory.key]?.length || 0} delicious options to explore</p>
                </div>

                <div className="category-content">
                    {loadingCategories[selectedCategory.key] ? (
                        <div className="skeleton-container">
                            {[1, 2, 3, 4, 5, 6].map(n => (
                                <div key={n} className="recipe-skeleton">
                                    <div className="skeleton-img"></div>
                                    <div className="skeleton-title"></div>
                                    <div className="skeleton-meta"></div>
                                </div>
                            ))}
                        </div>
                    ) : categoryRecipes[selectedCategory.key]?.length > 0 ? (
                        <div className="recipes-grid">
                            {categoryRecipes[selectedCategory.key].map(recipe => (
                                <div className="recipe-item" key={recipe.id}>
                                    <RecipeCard recipe={recipe} onClick={onRecipeClick} />
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="empty-state">
                            <i className="pi pi-inbox"></i>
                            <h3>No recipes found</h3>
                            <p>We couldn't find any recipes in this category.</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="categories-showcase">
            {lastUpdated && (
                <div className="update-badge">
                    <i className="pi pi-calendar"></i>
                    <span>Updated {new Date(lastUpdated).toLocaleDateString('en-US', {
                        month: 'short', day: 'numeric', year: 'numeric'
                    })}</span>
                </div>
            )}

            <div className="categories-container">
                {categories.map((category) => (
                    <div className="category-card" key={category.key} onClick={() => onCategoryClick(category)}>
                        <div className="category-card-inner" style={{
                            backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.6)), url(${categoryImages[category.key] || lunchImg})`,                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            color: '#fff'
                        }}>
                            <div className="category-content">
                                <h3>{category.name}</h3>
                                <div className="category-meta">
                                    {loadingCategories[category.key] ? (
                                        <div className="loading-dot-pulse"></div>
                                    ) : (
                                        <span>+ {categoryRecipes[category.key]?.length || 0} recipes</span>
                                    )}
                                    <i className="pi pi-angle-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CategoryShowcase;
